import { toggleClassWhenSticky } from "../utils/toggle-class-when-sticky";

export default function initNav(): void {
    const $navContainer = document.querySelectorAll<HTMLElement>('.js-main-header');

    $navContainer.forEach($container => {
        new Nav($container);
    });
}

class Nav {
    $body: HTMLElement | null | undefined;
    $el: HTMLElement | null | undefined;
    navBreakpoint: number;

    constructor($el: HTMLElement | null) {
        this.$body = document.querySelector('body');
        this.$el = $el;
        this.navBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xl'));
        window.addEventListener('resize', this.onWindowResize.bind(this));
        this.onWindowResize();
        this.init();
        this.toggleMenu();
    }


    onWindowResize(): void {

        if (window.innerWidth < this.navBreakpoint) {
            this.$el?.classList.add('header-mobile');

        } else if (window.innerWidth > this.navBreakpoint) {
            this.$el?.classList.remove('header-mobile');
            this.$el?.classList.remove('main-header-menu--active');
        }
    }

    init(): void {
        if (this.$el) {
            toggleClassWhenSticky(this.$el, 'main-header-sticky');
        }
    }

    toggleMenu(): void {
        const $burgerBtn = this.$el?.querySelector('.js-burger-btn');

        
        $burgerBtn?.addEventListener('click', () => {
            this.$el?.classList.toggle('main-header-menu--active');
        });
    }
}
